import type { IconProps } from "./icon-types";

/**
 * Plug 공용 UI glyph.
 *
 * Lucide의 `LuPlug` geometry를 정적 SVG로 인라인 — c6 패키지는 외부 아이콘
 * 라이브러리를 런타임 의존하지 않는다(RFC-design-system-split §아이콘).
 */
export const PlugIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M12 22v-5" />
    <path d="M9 8V2" />
    <path d="M15 8V2" />
    <path d="M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z" />
  </svg>
);
